export default "__VITE_ASSET__Cx6D9dsO__"